(ns app.strive-forms.question-fields.boolean-field
  (:require [app.strive-forms.component-multi-methods :refer [calc-error-message
                                                              show-action-btn?]]
            [app.strive-forms.defaults :refer [default-values]]
            [app.strive-forms.events :as events]
            [app.strive-forms.helper-functions :refer [check-question-visibility component-alignment
                                                       disable-continue-button enable-continue-button get-border-color
                                                       get-default-text-val get-required-message update-preview-panel!]]
            [app.strive-forms.question-components :refer [letter-checkbox]]
            [app.strive-forms.styles :refer [boolean-field-component-style
                                             warning-notification]]
            [clojure.string :refer [lower-case upper-case]]
            [clojure.string :as s]
            [keybind.core :as key]
            [re-com.core :as re-com :refer [v-box]]
            [re-frame.core :as re-frame]
            [reagent.core :as r]))

(defmethod show-action-btn? "boolean" [props]
  false)

(defn- process-response! [{:keys [input-data field-id text-val current-page index regenerate-display-fields
                                  on-submit is-multi-question?]}]
  (re-frame/dispatch [::events/update-input-local {:input-data input-data :key (keyword field-id) :value @text-val}])
  (regenerate-display-fields
   (update input-data (keyword field-id) (fn [value]
                                           (assoc value :value @text-val))))
  (when (some? @text-val)
    (when-not is-multi-question? (reset! current-page (+ 1 index)))
    (when (= (+ 1 index) (- (count input-data) 1))
      (on-submit))))

(defn get-boolean-value! [value text-val]
  (cond
    (and (= value :true) (not= @text-val (:boolean-true-value default-values))) (:boolean-true-value default-values)
    (and (= value :false) (not= @text-val (:boolean-false-value default-values))) (:boolean-false-value default-values)
    (or (and (= value :true) (= @text-val (:boolean-true-value default-values)))
        (and (= value :false) (= @text-val (:boolean-false-value default-values)))) nil))

(defn on-click-boolean [{:keys [input-data field-id text-val current-page index is-multi-question? regenerate-display-fields on-submit  value]}]
  (reset! text-val (get-boolean-value! value text-val))
  (process-response! {:input-data input-data :field-id field-id :text-val text-val
                      :current-page current-page :index index :is-multi-question? is-multi-question?
                      :regenerate-display-fields regenerate-display-fields :on-submit on-submit :value value}))

(defn get-border-size [{:keys [text-val value]}]
  (str (if (= @text-val value) 2 1) "px solid"))


(defn select-based-on-key-down [{:keys [text-val input-data field-id current-page index
                                        regenerate-display-fields on-submit value is-multi-question?]}]
  (fn []
    (on-click-boolean {:input-data input-data :field-id field-id :text-val text-val
                       :current-page current-page :index index :is-multi-question? is-multi-question?
                       :regenerate-display-fields regenerate-display-fields :on-submit on-submit :value value})))

(defn keyboard-listener-on! [{:keys [text-val true-letter false-letter input-data current-page index
                                     regenerate-display-fields on-submit visible-id? visible? is-multi-question?]}]
  (let [trigger-true (-> true-letter
                         lower-case
                         (key/bind! ::my-trigger (select-based-on-key-down {:text-val text-val :visible? visible?
                                                                            :input-data input-data :field-id visible-id?
                                                                            :current-page current-page :index index
                                                                            :regenerate-display-fields regenerate-display-fields :on-submit on-submit
                                                                            :value :true :is-multi-question? is-multi-question?})))
        trigger-false (-> false-letter
                          lower-case
                          (key/bind! ::my-trigger (select-based-on-key-down {:text-val text-val :visible? visible?
                                                                             :input-data input-data :field-id visible-id?
                                                                             :current-page current-page :index index
                                                                             :regenerate-display-fields regenerate-display-fields :on-submit on-submit
                                                                             :value :false :is-multi-question? is-multi-question?})))]
    (merge trigger-true trigger-false)))


(defn keyboard-listener-off! [{:keys [true-letter false-letter]}]
  (key/unbind! true-letter ::my-trigger)
  (key/unbind! false-letter ::my-trigger))

(defn boolean-button [{:keys [action label value answer-color buttons-color
                              answers-background-color answers-border-color border-size text-val]}]
  [:div
   {:on-click action
    :class (boolean-field-component-style {:border-size border-size
                                           :accent-color (or answer-color buttons-color)
                                           :background (or answer-color answers-background-color)
                                           :border (str border-size (get-border-color {:answer-color answer-color
                                                                                       :answers-border-color answers-border-color
                                                                                       :buttons-color buttons-color :text-val text-val
                                                                                       :value value}))})}

   (letter-checkbox {:letter (if (= value "1")
                               (upper-case (:boolean-true-letter default-values))
                               (upper-case (:boolean-false-letter default-values)))
                     :fill-color (or answer-color buttons-color) ;(border-color-for-list-item selections item theme-data)
                     :condition-to-fill-color (= @text-val value)
                     :neutral-color "white"})
   label])

(defn boolean-fields-area [{:keys [form-messages text-val theme-data field input-data field-id current-page index
                                   regenerate-display-fields on-submit is-multi-question?]}]
  [v-box
   :children [[boolean-button
               {:label (:yes_button_text form-messages)
                :value (:boolean-true-value default-values)
                :answer-color (:true_color (:additional_settings field))
                :model text-val
                :answers-background-color (:answers_background_color theme-data)
                :answers-border-color (:answers_border_color theme-data)
                :buttons-color (:buttons_color theme-data)
                :border-size (get-border-size {:text-val text-val :value (:boolean-true-value default-values)})
                :text-val text-val
                :action (partial on-click-boolean {:input-data input-data :field-id field-id :text-val text-val
                                                   :current-page current-page :index index :is-multi-question? is-multi-question?
                                                   :regenerate-display-fields regenerate-display-fields :on-submit on-submit :value :true})}]
              [boolean-button
               {:label (:no_button_text form-messages)
                :value (:boolean-false-value default-values)
                :answer-color (:false_color (:additional_settings field))
                :model text-val
                :buttons-color (:buttons_color theme-data)
                :answers-background-color (:answers_background_color theme-data)
                :answers-border-color (:answers_border_color theme-data)
                :border-size (get-border-size {:text-val text-val :value (:boolean-false-value default-values)})
                :text-val text-val
                :action (partial on-click-boolean {:input-data input-data :field-id field-id :text-val text-val
                                                   :current-page current-page :index index :is-multi-question? is-multi-question?
                                                   :regenerate-display-fields regenerate-display-fields :on-submit on-submit :value :false})}]]])

(defn bool-field [{:keys [field-id input-data visible? visible-id? default-value button-ids-for-button current-page index]}]
  (let [text-val (r/atom (get-default-text-val {:input-data input-data :field-id field-id :default-value default-value
                                                :type :boolean :current-page current-page :index index}))]
    (when (not (s/blank? @text-val)) (enable-continue-button {:button-ids-for-button button-ids-for-button :field-id (keyword field-id)}))
    (when @visible?
      (fn [{:keys [field-id form-messages  on-submit regenerate-display-fields 
                   field  index  theme-data current-page input-data is-multi-question? button-ids-for-button]}]
        (let [text-val (r/atom (get-default-text-val {:input-data input-data :field-id field-id :default-value default-value
                                                      :type :boolean :current-page current-page :index index}))]
          (update-preview-panel! {:input-data input-data :field-id field-id
                                  :value-to-update @text-val
                                  :condition (not (s/blank? @text-val))})
          (check-question-visibility {:index index :current-page current-page :visible? visible?})
             (when (false? is-multi-question?)
               (if @visible?
                 (keyboard-listener-on! {:text-val text-val :visible-id? @visible-id?
                                         :true-letter (:boolean-true-letter default-values)
                                         :false-letter (:boolean-false-letter default-values)
                                         :input-data input-data :visible? visible?
                                         :current-page current-page :index index
                                         :regenerate-display-fields regenerate-display-fields :on-submit on-submit
                                         :is-multi-question? is-multi-question?})
                 (keyboard-listener-off! {:true-letter (:boolean-true-letter default-values)
                                          :false-letter (:boolean-false-letter default-values)})))

             (add-watch text-val :watcher
                        (fn []
                          (if (not (s/blank? @text-val))
                            (enable-continue-button {:button-ids-for-button button-ids-for-button :field-id (keyword field-id)})
                            (disable-continue-button {:button-ids-for-button button-ids-for-button :field-id (keyword field-id)}))))
             [v-box
              :width "100%"
              :align (component-alignment is-multi-question?)
              :justify :center
              :children [[:div
                          [boolean-fields-area {:form-messages form-messages :text-val text-val :theme-data theme-data :field field
                                                :input-data input-data :field-id field-id :current-page current-page :index index
                                                :regenerate-display-fields regenerate-display-fields :on-submit on-submit
                                                :is-multi-question? is-multi-question?}]]]])))))